<template>
  <div class="finance-website">
    <!-- 头部区域 -->
    <header class="site-header">
      <div class="container">
        <div class="header-content">
          <!-- 公司Logo和名称 -->
          <div class="logo-container">
            <img src="../../assets/images/logo_200.png" alt="江山恒泰集团Logo" class="company-logo">
            <h1 class="company-name">江山恒泰集团</h1>
          </div>
 
          <!-- 桌面端导航 -->
          <nav class="desktop-nav">
            <ul class="nav-list">
              <li v-for="(item, index) in navItems" :key="index" :class="{ 'active': currentIndex === index }"
                @click="switchSection(index)" class="nav-item">
                {{ item.name }}
              </li>
            </ul>
          </nav>
 
          <!-- 移动端菜单按钮 -->
          <button class="mobile-menu-btn" @click="toggleMobileMenu">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
 
        <!-- 移动端导航菜单 -->
        <div class="mobile-nav" v-if="showMobileMenu">
          <ul class="mobile-nav-list">
            <li v-for="(item, index) in navItems" :key="index" :class="{ 'active': currentIndex === index }"
              @click="switchSection(index); toggleMobileMenu()" class="mobile-nav-item">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </header>
 
    <!-- 主体内容区域 -->
    <main class="main-content" @touchstart.stop="handleTouchStart" @touchmove.stop="handleTouchMove"
      @touchend.stop="handleTouchEnd" ref="mainContent">
      <!-- 切换指示器 -->
      <div class="nav-indicator left-indicator" @click.stop="prev">
        <i class="indicator-icon left-icon"></i>
      </div>
      <div class="nav-indicator right-indicator" @click.stop="next">
        <i class="indicator-icon right-icon"></i>
      </div>
 
      <!-- 公司介绍 -->
      <section v-if="currentIndex === 0" class="content-section company-intro">
        <div class="container">
          <h2 class="section-title">公司介绍</h2>
          <div class="section-content">
            <div class="intro-text">
              <p>江山恒泰集团成立于2025年，隶属于北京新通盈创科技有限公司，为国有企业，下辖有资产评估所、会计师事务所等机构。截至目前，集团已累计服务超千家企业，拥有百余位员工。公司凭借专业的团队和优质的服务，赢得了市场的高度认可，成为行业内的佼佼者。</p>
              <p>目前，作为国内唯一一家知识产权实缴国有企业，集团拥有完善的业务资质和经营牌照，在全国各省市拥有上千家合作伙伴。公司凭借强大的品牌影响力和专业服务能力，引领行业发展，为合作伙伴提供了广阔的市场空间和合作机会。</p>
              <p>公司专注于企业注册资本实缴，帮助企业合法合规的以知识产权完成实缴。这一创新服务模式，为企业解决了注册资本实缴的难题，降低了企业运营成本，提升了企业的市场竞争力。</p>
            </div>
            <div class="intro-image">
              <img src="../../assets/images/logo_1040.png" alt="办公楼" class="section-img">
            </div>
          </div>
        </div>
      </section>
 
      <!-- 主营业务 -->
      <section v-if="currentIndex === 1" class="content-section business-intro">
        <div class="container">
          <h2 class="section-title">主营业务</h2>
          <div class="section-content">
            <div class="business-cards">
              <div class="business-card">
                <img src="../../assets/images/business/b01.png" alt="资产评估" class="business-img">
                <h2 class="business-title">资产评估</h2>
              </div>
              <div class="business-card">
                <img src="../../assets/images/business/b02.png" alt="咨询服务" class="business-img">
                <h2 class="business-title">咨询服务</h2>
              </div>
              <div class="business-card">
                <img src="../../assets/images/business/b03.png" alt="注册实缴" class="business-img">
                <h2 class="business-title">注册实缴</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      <!-- 新闻资讯 -->
      <section v-if="currentIndex === 2" class="content-section news-section">
        <div class="container">
          <h2 class="section-title">新闻资讯</h2>
          
          <!-- 新闻列表 -->
          <div v-if="!selectedNews" class="section-content">
            <div class="news-list">
              <div v-for="news in newsList" :key="news.id" class="news-item" @click="showNewsDetail(news)">
                <div class="news-image">
                  <img :src="news.image" :alt="news.title" class="news-img">
                </div>
                <div class="news-content">
                  <div class="news-meta">
                    <span class="news-category">{{ news.category }}</span>
                    <span class="news-date">{{ news.date }}</span>
                  </div>
                  <h3 class="news-title">{{ news.title }}</h3>
                  <p class="news-summary">{{ news.summary }}</p>
                  <div class="news-read-more">
                    阅读更多 <i class="fa fa-angle-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 新闻详情 -->
          <div v-if="selectedNews" class="news-detail">
            <button class="back-to-list" @click="backToList()">
              <i class="fa fa-angle-left"></i> 返回列表
            </button>
            <div class="news-detail-header">
              <h3 class="news-detail-title">{{ selectedNews.title }}</h3>
              <div class="news-detail-meta">
                <span class="news-detail-category">{{ selectedNews.category }}</span>
                <span class="news-detail-date">{{ selectedNews.date }}</span>
              </div>
            </div>
            <!-- <div class="news-detail-image">
              <img :src="selectedNews.image" :alt="selectedNews.title" class="news-detail-img">
            </div> -->
            <div class="news-detail-content">
              <p class="news-detail-summary">{{ selectedNews.summary }}</p>
              <p v-for="(paragraph, index) in selectedNews.paragraphs" :key="index" class="news-detail-paragraph">{{paragraph}}</p>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 招商合作 -->
      <section v-if="currentIndex === 3" class="content-section cooperation-section">
        <div class="container">
          <h2 class="section-title">招商合作</h2>
          <div class="section-content">
            <div class="cooperation-list">
              <div v-for="project in cooperationProjects" :key="project.id" class="cooperation-item">
                <div class="cooperation-header">
                  <h3 class="cooperation-title">{{ project.title }}</h3>
                  <div class="cooperation-meta">
                    <span class="cooperation-area">{{ project.area }}</span>
                    <span class="cooperation-investment">{{ project.investment }}</span>
                  </div>
                </div>
                <div class="cooperation-content">
                  <div class="cooperation-description">
                    <h4 class="cooperation-subtitle">项目介绍</h4>
                    <p>{{ project.description }}</p>
                  </div>
                  <div class="cooperation-requirements">
                    <h4 class="cooperation-subtitle">合作要求</h4>
                    <p>{{ project.requirements }}</p>
                  </div>
                  <div class="cooperation-contact">
                    <h4 class="cooperation-subtitle">联系方式</h4>
                    <p>{{ project.contact }}</p>
                  </div>
                  <button class="cooperation-btn" @click="showCooperationForm(project)">
                    申请合作
                  </button>
                </div>
              </div>
            </div>
            
            <!-- 合作申请表单 -->
            <div v-if="showCooperationFormFlag" class="cooperation-form-modal">
              <div class="cooperation-form-overlay" @click="closeCooperationForm"></div>
              <div class="cooperation-form-content">
                <div class="cooperation-form-header">
                  <h3 class="cooperation-form-title">合作申请 - {{ selectedProject.title }}</h3>
                  <button class="cooperation-form-close" @click="closeCooperationForm">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <form class="cooperation-form">
                  <div class="form-group">
                    <label for="companyName">公司名称</label>
                    <input type="text" id="companyName" v-model="cooperation.name" class="form-control" placeholder="请输入公司名称">
                  </div>
                  <div class="form-group">
                    <label for="contactPerson">联系人</label>
                    <input type="text" id="contactPerson" v-model="cooperation.name" class="form-control" placeholder="请输入联系人姓名">
                  </div>
                  <div class="form-group">
                    <label for="contactPhone">联系电话</label>
                    <input type="tel" id="contactPhone" v-model="cooperation.phoneNumber" class="form-control" placeholder="请输入联系电话">
                  </div>
                  <div class="form-group">
                    <label for="contactEmail">电子邮箱</label>
                    <input type="email" id="contactEmail" v-model="cooperation.email" class="form-control" placeholder="请输入电子邮箱">
                  </div>
                  <div class="form-group">
                    <label for="cooperationDesc">合作说明</label>
                    <textarea id="cooperationDesc" v-model="cooperation.note" rows="4" class="form-control" placeholder="请简要描述您的合作意向和优势"></textarea>
                  </div>
                  <div class="form-actions">
                    <button type="button" class="cancel-btn" @click="closeCooperationForm">取消</button>
                    <button type="button" class="submit-btn" @click="submitCooperationForm">提交申请</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      <!-- 联系我们 -->
      <section v-if="currentIndex === 4" class="content-section contact-us">
        <div class="container">
          <h2 class="section-title">联系我们</h2>
          <div class="section-content">
            <div class="contact-info">
              <h3 class="contact-title">联系方式</h3>
              <p><i class="contact-icon location-icon"></i>上海市浦东新区陆家嘴软件园</p>
              <p><i class="contact-icon email-icon"></i>jiangshanhentai@163.com</p>
            </div>
            <div class="contact-form">
              <h3 class="form-title">发送咨询</h3>
              <form class="feedback-form">
                <div class="form-group">
                  <label for="name">姓名</label>
                  <input type="text" id="name" class="form-control" placeholder="请输入您的姓名">
                </div>
                <div class="form-group">
                  <label for="phone">电话</label>
                  <input type="tel" id="phone" class="form-control" placeholder="请输入您的电话">
                </div>
                <div class="form-group">
                  <label for="email">邮箱</label>
                  <input type="email" id="email" class="form-control" placeholder="请输入您的邮箱">
                </div>
                <div class="form-group">
                  <label for="message">留言</label>
                  <textarea id="message" rows="4" class="form-control" placeholder="请输入您的留言"></textarea>
                </div>
                <button type="button" class="submit-btn">提交</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
 
    <!-- 底部信息 -->
    <footer class="site-footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-logo">
            <img src="../../assets/images/logo_200.png" alt="江山恒泰集团Logo" class="footer-logo-img">
            <p class="footer-logo-text">江山恒泰集团 © 2025 版权所有</p>
          </div>
          <div class="footer-links">
            <a href="#" class="footer-link">关于我们</a>
            <a href="#" class="footer-link">隐私政策</a>
            <a href="#" class="footer-link">服务条款</a>
            <a href="#" class="footer-link">网站地图</a>
          </div>
          <div class="footer-copyright">
            <p>沪ICP备2025134282号</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
 
<script>
export default {
  name: 'App',
  data() {
    return {
      // 导航菜单数据
      navItems: [
        { name: '公司介绍' },
        { name: '主营业务' },
        { name: '新闻资讯' },
        { name: '招商合作' },
        { name: '联系我们' }
      ],
      // 新闻资讯数据
      newsList: [
        {
          id: 1,
          title: '国务院关于实施《中华人民共和国公司法》注册资本登记管理制度的规定',
          summary: '《国务院关于实施〈中华人民共和国公司法〉注册资本登记管理制度的规定》已经2024年6月7日国务院第34次常务会议通过，自2024年7月1日公布施行。',
          date: '2025-09-15',
          image: require('../../assets/images/news/n01.png'),
          category: '法规',
          paragraphs: [
            '第一条　为了加强公司注册资本登记管理，规范股东依法履行出资义务，维护市场交易安全，优化营商环境，根据《中华人民共和国公司法》（以下简称公司法），制定本规定。',
            '第二条　2024年6月30日前登记设立的公司，有限责任公司剩余认缴出资期限自2027年7月1日起超过5年的，应当在2027年6月30日前将其剩余认缴出资期限调整至5年内并记载于公司章程，股东应当在调整后的认缴出资期限内足额缴纳认缴的出资额；股份有限公司的发起人应当在2027年6月30日前按照其认购的股份全额缴纳股款。',
            '公司生产经营涉及国家利益或者重大公共利益，国务院有关主管部门或者省级人民政府提出意见的，国务院市场监督管理部门可以同意其按原出资期限出资。',
            '第三条　公司出资期限、注册资本明显异常的，公司登记机关可以结合公司的经营范围、经营状况以及股东的出资能力、主营项目、资产规模等进行研判，认定违背真实性、合理性原则的，可以依法要求其及时调整。',
            '第四条　公司调整股东认缴和实缴的出资额、出资方式、出资期限，或者调整发起人认购的股份数等，应当自相关信息产生之日起20个工作日内通过国家企业信用信息公示系统向社会公示。',
            '公司应当确保前款公示信息真实、准确、完整。',
            '第五条　公司登记机关采取随机抽取检查对象、随机选派执法检查人员的方式，对公司公示认缴和实缴情况进行监督检查。',
            '公司登记机关应当加强与有关部门的信息互联共享，根据公司的信用风险状况实施分类监管，强化信用风险分类结果的综合应用。',
            '第六条　公司未按照本规定调整出资期限、注册资本的，由公司登记机关责令改正；逾期未改正的，由公司登记机关在国家企业信用信息公示系统作出特别标注并向社会公示。',
            '第七条　公司因被吊销营业执照、责令关闭或者被撤销，或者通过其住所、经营场所无法联系被列入经营异常名录，出资期限、注册资本不符合本规定且无法调整的，公司登记机关对其另册管理，在国家企业信用信息公示系统作出特别标注并向社会公示。',
            '第八条　公司自被吊销营业执照、责令关闭或者被撤销之日起，满3年未向公司登记机关申请注销公司登记的，公司登记机关可以通过国家企业信用信息公示系统予以公告，公告期限不少于60日。',
            '公告期内，相关部门、债权人以及其他利害关系人向公司登记机关提出异议的，注销程序终止。公告期限届满后无异议的，公司登记机关可以注销公司登记，并在国家企业信用信息公示系统作出特别标注。',
            '第九条　公司的股东或者发起人未按照本规定缴纳认缴的出资额或者股款，或者公司未依法公示有关信息的，依照公司法、《企业信息公示暂行条例》的有关规定予以处罚。',
            '第十条　公司登记机关应当对公司调整出资期限、注册资本加强指导，制定具体操作指南，优化办理流程，提高登记效率，提升登记便利化水平。',
            '第十一条　国务院市场监督管理部门根据本规定，制定公司注册资本登记管理的具体实施办法。',
            '第十二条　上市公司依照公司法和国务院规定，在公司章程中规定在董事会中设置审计委员会，并载明审计委员会的组成、职权等事项。',
            '第十三条　本规定自公布之日起施行。',
          ]
        },
        {
          id: 2,
          title: '2024年7月1日起，有限责任公司的认缴出资额需五年内缴足',
          summary: '第十四届全国人民代表大会常务委员会第七次会议于2023年12月29日表决通过了新修订的《中华人民共和国公司法》（下称“新《公司法》”），将于2024年7月1日起正式实施！（点击可查看http://www.gov.cn/yaowen/liebiao/202312/content_6923395.htm）',
          date: '2025-09-15',
          image: require('../../assets/images/news/n02.png'),
          category: '法规',
          paragraphs: [
            '问题一：新设立公司都要五年内实缴吗？',
            '答：自2024年7月1日起，新《公司法》实施后，新设立登记“有限责任公司”要在五年内完成实缴；“股份有限公司”应当在公司成立前完成实缴。',
            '新《公司法》第四十七条规定：有限责任公司的注册资本为在公司登记机关登记的全体股东认缴的出资额。全体股东认缴的出资额由股东按照公司章程的规定自公司成立之日起五年内缴足。',
            '法律、行政法规以及国务院决定对有限责任公司注册资本实缴、注册资本最低限额、股东出资期限另有规定的，从其规定。',
            '新《公司法》第九十八条第一款的规定：股份有限公司的发起人应当在公司成立前按照其认购的股份全额缴纳股款。',
            '问题二：新《公司法》施行前已登记设立的公司是否需实缴？',
            '答：根据新《公司法》第二百六十六条第二款规定：本法施行前已登记设立的公司，出资期限超过本法规定期限的，除法律、行政法规或者国务院另有规定外，应当逐步调整至本法规定的期限以内。对于出资期限、出资额明显异常的，公司登记机关可以依法要求其及时调整。具体实施办法由国务院规定。',
            '问题三：股东出资有规定出资方式吗？',
            '答：股东可以用货币出资，也可以用实物、知识产权、土地使用权、股权、债权等可以用货币估价并可以依法转让的非货币财产作价出资；但是，法律、行政法规规定不得作为出资的财产除外（新《公司法》第四十八条）。',
            '问题四：股东是否缴足认缴出资额，监管部门是怎样掌握相关情况的？',
            '答：新《公司法》进一步加强了公司的信息公示义务，对未按规定公示有关信息或者不如实公示有关信息的公司，将受到处罚。',
            '新《公司法》第四十条规定：公司应当通过国家企业信用信息公示系统公示有限责任公司股东认缴和实缴的出资额、出资方式和出资期限，股份有限公司发起人认购的股份数。',
            '新《公司法》第二百五十一条规定：对未按规定公示有关信息或者不如实公示有关信息的，由公司登记机关责令改正，可以处以1万元以上5万元以下的罚款。情节严重的，处以5万元以上20万元以下的罚款；对直接负责的主管人员和其他直接责任人员处以1万元以上10万元以下的罚款。',
            '问题五:如果公司发起人、股东没有按规定出资，会怎样？',
            '答：根据新《公司法》第二百五十二条规定：公司的发起人、股东虚假出资，未交付或者未按期交付作为出资的货币或者非货币财产的，由公司登记机关责令改正，可以处以5万元以上20万元以下的罚款；情节严重的，处以虚假出资或者未出资金额5%以上15%以下的罚款；对直接负责的主管人员和其他直接责任人员处以1万元以上10万元以下的罚款。'
          ]
        }
      ],
      // 当前选中的新闻
      selectedNews: null,
      // 招商合作项目数据
      cooperationProjects: [
        {
          id: 1,
          title: '企业非专利性知识产权',
          area: '全国',
          investment: '',
          description: '',
          requirements: '',
          contact: '邮箱 jiangshanhentai@163.com'
        }
      ],
      // 招商合作表单相关变量
      showCooperationFormFlag: false,
      selectedProject: null,
      // 当前显示的内容索引，默认显示公司介绍
      currentIndex: 0,
      // 移动端菜单显示状态
      showMobileMenu: false,
      // 滑动相关变量
      startX: 0,
      moveX: 0,
      isDragging: false,
      threshold: 100,
      cooperation: {
        name: '',
        phoneNumber: '',
        email: '',
        Note: ''
      }
    }
  },
  methods: {
    // 切换到指定章节
    switchSection(index) {
      this.currentIndex = index;
      // 关闭移动端菜单
      this.showMobileMenu = false;
      // console.log('switchSection', this.currentIndex)
    },
 
    // 切换到上一章节
    prev() {
      this.prevSection()
      // console.log('prev', this.currentIndex)
    },
 
    // 切换到下一章节
    next() {
      this.nextSection();
      // console.log('next', this.currentIndex)
    },
 
    // 切换到上一章节
    prevSection() {
      this.currentIndex = (this.currentIndex - 1 + this.navItems.length) % this.navItems.length;
    },
 
    // 切换到下一章节
    nextSection() {
      this.currentIndex = (this.currentIndex + 1) % this.navItems.length;
    },
 
    // 切换移动端菜单显示状态
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
 
    // 触摸开始事件
    handleTouchStart(e) {
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
    },
 
    // 触摸移动事件
    handleTouchMove(e) {
      if (this.isDragging) {
        this.moveX = e.touches[0].clientX;
      }
    },
 
    // 触摸结束事件
    handleTouchEnd() {
      // console.log('handleTouchEnd')
      if (this.isDragging) {
        const diffX = this.moveX - this.startX;
        // console.log('moveX', this.moveX)
        // console.log('startX', this.startX)
        // console.log('diffx', diffX)
        if (this.moveX != 0) {
          // 向右滑动超过阈值，切换到上一章节
          if (diffX > this.threshold) {
            this.prevSection();
          }
          // 向左滑动超过阈值，切换到下一章节
          else if (diffX < -this.threshold) {
            this.nextSection();
          }
        }
 
        // 重置拖动状态
        this.isDragging = false;
        this.startX = 0;
        this.moveX = 0;
      }
    },
    
    // 新闻资讯相关方法
    showNewsDetail(news) {
      this.selectedNews = news;
      // 禁用滑动功能
      this.isDragging = false;
    },
    
    backToList() {
      this.selectedNews = null;
    },
    
    // 招商合作相关方法
    showCooperationForm(project) {
      this.selectedProject = project;
      this.showCooperationFormFlag = true;
      // 禁用滑动功能
      this.isDragging = false;
    },
    
    closeCooperationForm() {
      this.showCooperationFormFlag = false;
      this.selectedProject = null;
    },
    
    submitCooperationForm() {
      
      // 简单验证
      if (!this.cooperation.name) {
        alert('请填写联系人称呼');
        return;
      }
      // 简单验证
      if (!this.cooperation.phoneNumber) {
        alert('请填写联系人电话');
        return;
      }
      
      // 模拟提交成功
      alert('合作申请已提交成功，我们将尽快与您联系！');
      
      // 关闭表单
      this.closeCooperationForm();
      
      // 重置表单
        this.cooperation.name = '';
        this.cooperation.phoneNumber = '';
        this.cooperation.email = '';
        this.cooperation.note = '';
      
    }
  }
}
</script>
 
<style lang="less" scoped>
/* 基础样式 */
.finance-website {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
  background-color: #f9f9f9;
  line-height: 1.6;
}
 
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
 
/* 头部样式 */
.site-header {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
 
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}
 
.logo-container {
  display: flex;
  align-items: center;
}
 
.company-logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 4px;
}
 
.company-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0a2463;
  /* 深蓝色 - 财经风格主色 */
  margin: 0;
}
 
/* 桌面端导航 */
.desktop-nav {
  display: block;
}
 
.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}
 
.nav-item {
  margin-left: 30px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  position: relative;
  transition: color 0.3s;
}
 
.nav-item:hover {
  color: #0a2463;
}
 
.nav-item.active {
  color: #0a2463;
}
 
.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #0a2463;
}
 
/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
}
 
.icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  background-color: #333;
  margin: 4px 0;
  transition: 0.4s;
}
 
/* 移动端导航 */
.mobile-nav {
  display: none;
  background-color: #fff;
  border-top: 1px solid #eee;
  padding: 10px 0;
}
 
.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
 
.mobile-nav-item {
  padding: 10px 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  transition: color 0.3s;
}
 
.mobile-nav-item:last-child {
  border-bottom: none;
}
 
.mobile-nav-item:hover {
  color: #0a2463;
}
 
.mobile-nav-item.active {
  color: #0a2463;
  font-weight: 600;
}
 
/* 主体内容样式 */
.main-content {
  margin-top: 80px;
  min-height: calc(100vh - 180px);
  position: relative;
  overflow: hidden;
}
 
 
.content-section {
  padding: 60px 0;
  /*opacity: 0;*/
  transform: translateX(0);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
 
/*
.content-section:nth-child(n+3) {
  display: none;
}
 
.content-section:not([v-if]) {
  display: none;
}
*/
.content-section[v-if="currentIndex === 0"],
.content-section[v-if="currentIndex === 1"],
.content-section[v-if="currentIndex === 2"],
.content-section[v-if="currentIndex === 3"],
.content-section[v-if="currentIndex === 4"] {
  display: block;
  opacity: 1;
  transform: translateX(0);
}
 
/**/
.section-title {
  text-align: center;
  font-size: 2rem;
  color: #0a2463;
  margin-bottom: 40px;
  font-weight: 600;
  position: relative;
  padding-bottom: 15px;
}
 
.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 105px;
  height: 2px;
  background-color: #0a2463;
}
 
.section-content {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
 
/* 公司介绍样式 */
.company-intro .section-content {
  flex-direction: row;
}
 
.intro-text {
  flex: 1;
  min-width: 300px;
}
 
.intro-text p {
  margin-bottom: 15px;
  color: #555;
}
 
.intro-image {
  flex: 1;
  min-width: 300px;
}
 
.section-img {
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
 
/* 业务介绍样式 */
.business-intro .section-content {
  justify-content: center;
}
 
.business-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  width: 100%;
}
 
.business-card {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s, box-shadow 0.3s;
}
 
.business-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
 
.business-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}
 
.business-title {
  // font-size: 1.2rem;
  color: #0a2463;
  padding: 20px 20px 10px;
  margin: 0;
  text-align: center;
}
 
.business-desc {
  padding: 0 20px 20px;
  margin: 0;
  color: #555;
}
 
/* 新闻资讯样式 */
.news-section .section-content {
  width: 100%;
}
 
.news-list {
  width: 100%;
}
 
.news-item {
  display: flex;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
}
 
.news-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}
 
.news-image {
  flex: 0 0 300px;
}
 
.news-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
 
.news-content {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
 
.news-meta {
  display: flex;
  margin-bottom: 10px;
  font-size: 0.85rem;
  color: #999;
}
 
.news-category {
  margin-right: 15px;
  color: #0a2463;
  font-weight: 500;
}
 
.news-title {
  font-size: 1.2rem;
  color: #333;
  margin: 0 0 10px 0;
  transition: color 0.3s;
}
 
.news-item:hover .news-title {
  color: #0a2463;
}
 
.news-summary {
  color: #555;
  margin: 0 0 15px 0;
  flex: 1;
}
 
.news-read-more {
  color: #0a2463;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
}
 
.news-read-more i {
  margin-left: 5px;
  transition: transform 0.3s;
}
 
.news-item:hover .news-read-more i {
  transform: translateX(5px);
}
 
/* 新闻详情样式 */
.news-detail {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
 
.back-to-list {
  display: inline-flex;
  align-items: center;
  color: #0a2463;
  background: transparent;
  border: none;
  padding: 5px 0;
  margin-bottom: 20px;
  cursor: pointer;
  font-size: 0.9rem;
}
 
.back-to-list i {
  margin-right: 5px;
}
 
.news-detail-header {
  margin-bottom: 20px;
}
 
.news-detail-title {
  font-size: 1.5rem;
  color: #333;
  margin: 0 0 10px 0;
}
 
.news-detail-meta {
  display: flex;
  font-size: 0.9rem;
  color: #999;
}
 
.news-detail-category {
  margin-right: 15px;
  color: #0a2463;
  font-weight: 500;
}
 
.news-detail-image {
  margin-bottom: 30px;
}
 
.news-detail-img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
 
.news-detail-content {
  color: #555;
  line-height: 1.8;
}
 
.news-detail-summary {
  font-size: 1.1rem;
  margin-bottom: 20px;
  color: #333;
  font-weight: 500;
}
 
.news-detail-paragraph {
  margin-bottom: 15px;
}
 
/* 招商合作样式 */
.cooperation-section .section-content {
  width: 100%;
}
 
.cooperation-list {
  width: 100%;
}
 
.cooperation-item {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}
 
.cooperation-header {
  padding: 20px;
  background-color: #f5f7fa;
  border-left: 4px solid #0a2463;
}
 
.cooperation-title {
  font-size: 1.3rem;
  color: #333;
  margin: 0 0 10px 0;
}
 
.cooperation-meta {
  display: flex;
  font-size: 0.9rem;
  color: #666;
}
 
.cooperation-area {
  margin-right: 20px;
  display: flex;
  align-items: center;
}
 
.cooperation-area::before {
  content: '📍';
  margin-right: 5px;
}
 
.cooperation-investment {
  display: flex;
  align-items: center;
}
 
.cooperation-investment::before {
  content: '💰';
  margin-right: 5px;
}
 
.cooperation-content {
  padding: 20px;
}
 
.cooperation-subtitle {
  font-size: 1.1rem;
  color: #0a2463;
  margin: 0 0 10px 0;
}
 
.cooperation-description,
.cooperation-requirements,
.cooperation-contact {
  margin-bottom: 20px;
}
 
.cooperation-contact {
  margin-bottom: 25px;
}
 
.cooperation-btn {
  background-color: #0a2463;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}
 
.cooperation-btn:hover {
  background-color: #143683;
}
 
/* 合作申请表单样式 */
.cooperation-form-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
}
 
.cooperation-form-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
}
 
.cooperation-form-content {
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}
 
.cooperation-form-header {
  padding: 15px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
 
.cooperation-form-title {
  font-size: 1.2rem;
  color: #333;
  margin: 0;
}
 
.cooperation-form-close {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #666;
}
 
.cooperation-form {
  padding: 20px;
}
 
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
 
.cancel-btn {
  background-color: #eee;
  color: #333;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}
 
.cancel-btn:hover {
  background-color: #ddd;
}
 
/* 办公环境样式 */
.office-environment .section-content {
  justify-content: center;
}
 
.office-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  width: 100%;
}
 
.office-item {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
 
.office-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
 
.office-desc {
  padding: 15px;
  text-align: center;
  margin: 0;
  color: #555;
  background-color: #f5f7fa;
}
 
/* 招聘信息样式 */
.recruitment .section-content {
  justify-content: center;
  width: 100%;
}
 
.job-list {
  width: 100%;
  max-width: 800px;
}
 
.job-item {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
 
.job-title {
  font-size: 1.2rem;
  color: #0a2463;
  padding: 15px 20px;
  margin: 0;
  background-color: #f5f7fa;
  border-left: 4px solid #0a2463;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
 
.job-title::after {
  content: '+';
  font-size: 1.5rem;
  font-weight: 300;
  transition: transform 0.3s;
}
 
.job-item.active .job-title::after {
  transform: rotate(45deg);
}
 
.job-details {
  padding: 0 20px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s, padding 0.3s;
}
 
.job-item.active .job-details {
  padding: 20px;
  max-height: 500px;
}
 
.job-details p {
  margin-bottom: 10px;
}
 
.apply-btn {
  background-color: #0a2463;
  color: #fff;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s;
  margin-top: 10px;
}
 
.apply-btn:hover {
  background-color: #143683;
}
 
/* 联系我们样式 */
.contact-us .section-content {
  flex-direction: row;
  gap: 50px;
}
 
.contact-info,
.contact-form {
  flex: 1;
  min-width: 300px;
}
 
.contact-title,
.form-title {
  font-size: 1.3rem;
  color: #0a2463;
  margin-bottom: 20px;
  font-weight: 600;
}
 
.contact-icon {
  margin-right: 10px;
  color: #0a2463;
}
 
.contact-info p {
  margin-bottom: 15px;
}
 
.form-group {
  margin-bottom: 20px;
}
 
.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}
 
.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}
 
.form-control:focus {
  border-color: #0a2463;
  outline: none;
}
 
.submit-btn {
  background-color: #0a2463;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}
 
.submit-btn:hover {
  background-color: #143683;
}
 
/* 导航指示器样式 */
.nav-indicator {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
  opacity: 0.4;
  z-index: 1001;
  /* 确保在最上层 */
}
 
.nav-indicator:hover {
  background-color: #fff;
}
 
.left-indicator {
  left: 20px;
}
 
.right-indicator {
  right: 20px;
}
 
.indicator-icon {
  width: 0;
  height: 0;
  border-style: solid;
}
 
.left-icon {
  border-width: 10px 15px 10px 0;
  border-color: transparent #0a2463 transparent transparent;
}
 
.right-icon {
  border-width: 10px 0 10px 15px;
  border-color: transparent transparent transparent #0a2463;
}
 
/* 底部样式 */
.site-footer {
  background-color: #0a2463;
  color: #fff;
  padding: 40px 0 20px;
}
 
.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;
}
 
.footer-logo,
.footer-links,
.footer-copyright {
  flex: 1;
  min-width: 200px;
}
 
.footer-logo-img {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  margin-bottom: 10px;
}
 
.footer-logo-text {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}
 
.footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
 
.footer-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;
  font-size: 0.9rem;
}
 
.footer-link:hover {
  color: #fff;
  text-decoration: underline;
}
 
.footer-copyright {
  text-align: right;
}
 
.footer-copyright p {
  margin: 0 0 8px 0;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
}
 
/* 响应式设计 */
@media (max-width: 768px) {
  /* 新闻资讯响应式样式 */
  .news-item {
    flex-direction: column;
  }
  
  .news-image {
    flex: 0 0 200px;
  }
  
  .news-content {
    padding: 15px;
  }
  
  /* 新闻详情响应式样式 */
  .news-detail-title {
    font-size: 1.3rem;
  }
  
  /* 招商合作响应式样式 */
  .cooperation-meta {
    flex-direction: column;
    gap: 5px;
  }
  
  .cooperation-area {
    margin-right: 0;
  }
  
  /* 合作申请表单响应式样式 */
  .cooperation-form-content {
    width: 90%;
  }
 
  /* 导航适配 */
  .desktop-nav {
    display: none;
  }
 
  .mobile-menu-btn {
    display: block;
  }
 
  .mobile-nav {
    display: block;
  }
 
  /* 主体内容适配 */
  .main-content {
    margin-top: 70px;
  }
 
  .section-title {
    font-size: 1.6rem;
  }
 
  .company-intro .section-content,
  .contact-us .section-content {
    flex-direction: column;
  }
 
  .nav-indicator {
    width: 40px;
    height: 40px;
  }
 
  .left-indicator {
    left: 10px;
  }
 
  .right-indicator {
    right: 10px;
  }
 
  /* 底部适配 */
  .footer-content {
    flex-direction: column;
  }
 
  .footer-copyright {
    text-align: left;
  }
}
 
@media (max-width: 480px) {
  .company-name {
    font-size: 1.2rem;
  }
 
  .content-section {
    padding: 40px 20px;
  }
 
  .business-cards,
  .office-gallery {
    grid-template-columns: 1fr;
  }
}
</style>